/**
 * Represents a texture handle for the backbuffer color texture.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const backbufferColorTextureHandle = 0;
/**
 * Represents a texture handle for the backbuffer depth/stencil texture.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const backbufferDepthStencilTextureHandle = 1;
//# sourceMappingURL=frameGraphTypes.js.map